import root from 'window-or-global';
import { executeOnNextTick } from './';

/**
 * [scrollToTop]
 * Scroll to top of the page.
 */
export function scrollToTop() {
  executeOnNextTick(() => {
    root.scrollTo(0, 0);
  });
}
